export const themes = {
  rose: {
    highlightword: (props) => props.theme.colors.status.laSalleGreen,
    circle: {
      background: "#e2aed2",
      color: "#552c55",
      descriptionColor: "#152935"
    }
  }
};
